// extracted by mini-css-extract-plugin
export default {"content":"styles_content__avVOX","text":"styles_text__4tS8M styles_content__avVOX","checked":"styles_checked__Zf0Ap"};